import ButtonComponent from 'app_components/commons/Button/ButtonComponent'
import InputComponent from 'app_components/commons/Input/InputComponent'
import InputFileComponent from 'app_components/commons/InputFileComponent/InputFileComponent'
import LandingService from 'app_services/admin/landings/landingService'
import RoleService from 'app_services/admin/role/roleService'
import { ILandingTutorial, ILandingTutorialPrivateGroup, LandingTutorialType, LANDING_TUTORIAL_TYPE, TypeSlugLanding } from 'app_types/admin/landings/landingTypes'
import React, { FC, useCallback, useEffect, useMemo, useState } from 'react'
import { Form } from 'react-bootstrap'
import { Controller, useForm } from 'react-hook-form'
import ReactSelectComponent from 'app_components/commons/reactSelect';
import LabelComponent from 'app_components/commons/LabelComponent/LabelComponent'
import ReactSelectService from 'app_services/components/reactSelectService'
import { ITerm } from 'app_types/admin/term/term.types'

import './TutorialForm.scss'
import TutorialRoleForm from '../TutorialRoleForm/TutorialRoleForm'
import { IRoleListItem } from 'app_types/admin/role/roleTypes'

interface ITutorialFormProps {
  editData?: ILandingTutorial
  slug: TypeSlugLanding
  onClose?: (saved?: boolean) => void
  publicGroups: ITerm[]
}

const TutorialForm: FC<ITutorialFormProps> = ({ editData, slug, onClose, publicGroups }) => {
  const formHook = useForm({
    defaultValues: {
      ...editData,
      fileType: editData?.fileType ? editData?.fileType : LandingTutorialType.VIDEO,
      publicGroups: (editData?.publicGroups) ? editData?.publicGroups.map((r) => ({value: r?._id, label: r?.name})) : [],
    }
  })
  const fileType = formHook.watch('fileType')
  const landingService = useMemo(() => new LandingService(), []);
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const roleService: RoleService = new RoleService()
  const reactSelectService = useMemo(() => new ReactSelectService(), [])
  const [listOfRoles, setListOfRoles] = useState<Array<any>>([])

  useEffect(() => {
    formHook.register('privateGroups')
    getRoles()
  }, [])

  const getPrivateGroupsDefaultValue = () => {
    return (editData?.privateGroups) ? editData?.privateGroups?.map((privateGroup) => ({
      role: { label: (privateGroup?.role as IRoleListItem)?.description, value: (privateGroup?.role as IRoleListItem)?._id },
      groups: privateGroup?.groups ? privateGroup?.groups?.map((group) => ({ label: group.name, value: group._id })) : []
    })) : []
  }

  const publicGroupsOptions = useMemo(() => {
    return publicGroups?.map((group) => ({
      label: group.name,
      value: group._id
    }))
  }, [publicGroups])

  const getRoles = async () => {
    const roles: Array<any> = []
    const rolesResponse = await roleService.getRoles({})
    if (rolesResponse) {
      rolesResponse.roles.map((_role: any) => {
        roles.push({ value: _role._id, label: _role.description })
      })
    }
    setListOfRoles(roles)
  }

  const handleSubmitForm = useCallback(async (data: ILandingTutorial) => {
    data.slug = slug
    if (editData?.unique) {
      data.unique = editData.unique
    }
    if (data?.publicGroups?.length) {
      // @ts-ignore
      data.publicGroups = JSON.stringify(reactSelectService.formatReactSelectResponse(data.publicGroups))
    } else {
      // @ts-ignore
      data.publicGroups = JSON.stringify([])
    }
    if (data?.privateGroups?.length) {
      // @ts-ignore
      data.privateGroups = JSON.stringify(data.privateGroups.map((privateGroup) => ({
        // @ts-ignore
        role: privateGroup?.role?.value,
        // @ts-ignore
        groups: privateGroup?.groups?.length ? privateGroup?.groups?.map((group) => group?.value) : []
      })))
    } else {
      // @ts-ignore
      data.privateGroups = JSON.stringify([])
    }
    setIsLoading(true)
    const response = await landingService.saveTutorial(data)
    if (response?.tutorials) {
      onClose && onClose(true)
    }
    setIsLoading(false)
  }, [slug, editData, landingService, onClose, reactSelectService])

  const handleClickClose = () => {
    onClose && onClose()
  }

  const handleChangePrivateGroups = (newValue: ILandingTutorialPrivateGroup[]) => {
    formHook.setValue('privateGroups', newValue)
  }

  return (
    <div className="tutorial-form--layout">
      <form onSubmit={formHook.handleSubmit(handleSubmitForm)}>
        <div className="col-md-12 p-0">
          <div className="form-group">
            <Form.Check
              type='switch'
              id='active'
              name='active'
              label="Activo"
              defaultChecked={true}
              ref={formHook.register()}
            />
          </div>
        </div>
        <div className="col-md-12 p-0">
          <div className="form-group">
            <Form.Check
              type='checkbox'
              id='private'
              name='private'
              label="Privado"
              defaultChecked={false}
              ref={formHook.register()}
            />
          </div>
        </div>
        <InputComponent
          formHook={formHook.register({ required: true })}
          name="title"
          label="Titulo"
          invalid={!!formHook?.errors?.title}
          invalidText="El titulo es requerido"
        />
        <InputComponent
          formHook={formHook.register({ required: true })}
          name="description"
          label="Descripción"
          invalid={!!formHook?.errors?.description}
          invalidText="La descripción es requerida"
        />
        <div className="col-md-12 p-0">
          <div className="form-group">
            <LabelComponent>Grupos públicos</LabelComponent>
            <ReactSelectComponent
              identifier='publicGroups'
              options={publicGroupsOptions}
              formHooks={formHook}
              isMulti={true}
              required={false}
            />
          </div>
        </div>
        <div className="col-md-12 p-0">
          <TutorialRoleForm
            listOfRoles={listOfRoles}
            terms={publicGroups}
            onChange={handleChangePrivateGroups}
            defaultValue={getPrivateGroupsDefaultValue() as unknown as ILandingTutorialPrivateGroup[]}
          />
        </div>
        <InputFileComponent
          formHook={formHook as any}
          as="image"
          name="imageFile"
          label="Imagen"
          defaultUrl={editData?.imageUrl}
        />
        <div className="col-12 p-0">
          <div key={editData?.unique} className='form-group '>
            <label htmlFor='fileType'>Tipo de adjunto</label>
            {formHook.errors.fileType && <div className='invalid-feedback'>El tipo de adjunto es requerido</div>}
            <Controller
              control={formHook.control}
              name='fileType'
              render={({ ref, value, onChange }) => (
                <select
                  id='fileType'
                  className={`form-control ${formHook.errors.fileType && 'is-invalid'}`}
                  value={value}
                  ref={ref}
                  onChange={(e) => onChange(e.target.value)}
                >
                  <option value={LandingTutorialType.VIDEO}>
                    {LANDING_TUTORIAL_TYPE[LandingTutorialType.VIDEO]}
                  </option>
                  <option value={LandingTutorialType.IMAGE}>
                    {LANDING_TUTORIAL_TYPE[LandingTutorialType.IMAGE]}
                  </option>
                  <option value={LandingTutorialType.PDF}>
                    {LANDING_TUTORIAL_TYPE[LandingTutorialType.PDF]}
                  </option>
                </select>
              )}
            />
          </div>
        </div>
        {fileType !== 'video' && (
          <InputFileComponent
            formHook={formHook as any}
            as="file"
            name="attachFile"
            label="Adjunto"
            defaultUrl={editData?.attachUrl}
          />
        )}
        {fileType === 'video' && (
          <InputComponent
            formHook={formHook.register({ required: true })}
            name="videoUrl"
            label="Video URL"
            invalid={!!formHook?.errors?.videoUrl}
            invalidText="La url del video es requerida"
          />
        )}
        <div className='tutorial-form--actions'>
          <ButtonComponent onClick={handleClickClose} type="button">
            Cancelar
          </ButtonComponent>
          <ButtonComponent variant='primary' type="submit" loading={isLoading}>
            Guardar
          </ButtonComponent>
        </div>
      </form>
    </div>
  )
}

export default TutorialForm
